import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BreakpointService } from '@herrenknecht-connected/angular-shared-utils-core';
import { TranslateService } from '@ngx-translate/core';
import { PDFDocumentProxy, PdfViewerComponent } from 'ng2-pdf-viewer';
import printJS from 'print-js';

export interface ReportViewerData {
  download: () => void;
  getDocSrc: () => Promise<string>;
  hasBase64DocSrc: boolean;
}

@Component({
  selector: 'hk-report-viewer',
  templateUrl: './report-viewer.component.html',
})
export class ReportViewerModalComponent implements OnInit {
  zoom = 1;
  searchString = '';
  zoomMode = 'page-fit';
  docSrc?: string;
  showSpinner = true;
  numPages?: number;
  readonly availableZoomModes = ['page-width', 'page-fit', 'page-height'];
  @ViewChild(PdfViewerComponent) private _pdfComponent?: PdfViewerComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReportViewerData,
    public dialog: MatDialog,
    public translate: TranslateService,
    public breakpoints: BreakpointService,
  ) {}

  get selectedMatchCount() {
    return (this._pdfComponent?.pdfFindController?._selected?.matchIdx ?? 0) + 1;
  }

  get numMatches() {
    return this._pdfComponent?.pdfFindController?._matchesCountTotal;
  }

  ngOnInit(): void {
    this.data.getDocSrc().then((x) => (this.docSrc = x));
  }

  onAfterLoadCompleted(event_: PDFDocumentProxy) {
    this.showSpinner = false;
    this.numPages = event_._pdfInfo.numPages;
  }

  search(stringToSearch: string) {
    if (!this._pdfComponent) {
      return;
    }
    this.searchString = stringToSearch;

    this._pdfComponent.eventBus.dispatch('find', {
      query: stringToSearch,
      type: 'again',
      caseSensitive: false,
      findPrevious: undefined,
      highlightAll: true,
      phraseSearch: true,
    });
  }

  findNext() {
    this._navigateToMatch(false);
  }

  findPrevious() {
    this._navigateToMatch(true);
  }

  async print() {
    const documentSource = await this.data.getDocSrc();
    if (this.data.hasBase64DocSrc) {
      const help = documentSource.split(';base64,');
      printJS({
        printable: help.length === 2 ? help[1] : this.data.getDocSrc,
        type: 'pdf',
        base64: true,
      });
    } else {
      printJS(documentSource);
    }
  }

  private _navigateToMatch(previous: boolean) {
    this._pdfComponent?.eventBus.dispatch('find', {
      query: this.searchString,
      type: 'again',
      caseSensitive: false,
      findPrevious: previous ? true : undefined,
      highlightAll: true,
      phraseSearch: true,
    });
  }
}
